export default __webpack_public_path__ + "static/media/codescene.65c746f2.svg";